export type TAsyncContentStatus =
  | 'idle'
  | 'requesting'
  | 'starting'
  | 'downloading'
  | 'processing'
  | 'success'
  | 'error'
  | 'cancelled'

export interface IAsyncDownloadState {
  status: TAsyncContentStatus
  loadedBytes: number
  totalBytes: number | null
  remainingBytes: number | null
  percent: number | null
  startedAt: number | null
  finishedAt: number | null
  error: string | null
}

export const createInitialAsyncDownloadState = (): IAsyncDownloadState => ({
  status: 'idle',
  loadedBytes: 0,
  totalBytes: null,
  remainingBytes: null,
  percent: null,
  startedAt: null,
  finishedAt: null,
  error: null,
})
